import React from "react";
import "./SalePopup.scss";
import { useLocalStorage } from "../../../shared/utill";
import { format } from "date-fns";
import { useMediaQuery } from "react-responsive";

const NAME_CHANGE_STORAGE_KEY = "nameChangePopupClosedDate";

const NameChangePopup = () => {
  const [closeToday, setCloseToday] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(true);
  const [isTodayClosed, setIsTodayClosed] = useLocalStorage(
    NAME_CHANGE_STORAGE_KEY,
    {
      nowDate: "",
    }
  );
  const isMobile = useMediaQuery({
    query: "(max-width: 1200px)",
  });
  const nowDate = format(new Date(), "yyyy-MM-dd");
  React.useEffect(() => {
    if (isTodayClosed.nowDate === nowDate && isOpen) {
      setIsOpen(false);
    }
  }, [isTodayClosed, nowDate, isOpen]);

  const toggleCloseToday = React.useCallback(() => {
    setCloseToday(!closeToday);
  }, [closeToday, setCloseToday]);

  const close = React.useCallback(() => {
    if (closeToday) {
      setIsTodayClosed({ nowDate });
    }
    setIsOpen(false);
  }, [closeToday, setIsTodayClosed, setIsOpen, nowDate]);

  const onOverlayClick = React.useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      if (event.target === event.currentTarget) {
        close();
      }
    },
    [close]
  );

  return (
    <div>
      {isOpen && (
        <div className="sale-popup-wrap" onClick={onOverlayClick}>
          <div className="sale-popup name-change-popup">
            {isMobile ? (
              <img
                className="popup-img"
                src={require("../../../static/name-change-popup.png")}
                alt=""
              />
            ) : (
              <img
                className="popup-img"
                src={require("../../../static/name-change-popup.png")}
                alt=""
              />
            )}

            <div className="bottom-area">
              <div
                className={`close-today ${closeToday ? "active" : ""}`}
                onClick={toggleCloseToday}
              >
                오늘 하루 보지 않기
              </div>
              <div className="close" onClick={close}>
                닫기
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NameChangePopup;
